import React from 'react';
import PolicyPage from './PolicyPage';

export default function TermsOfService() {
  return (
    <PolicyPage title="Terms of Service">
      <p className="text-sm text-secondary-500">Last updated: {new Date().toLocaleDateString('en-US')}</p>
      <p>
        By using Driscollland’s website and services, you agree to these terms.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Services</h2>
      <p>
        We provide landscaping and lawn care services as described on our site. Service scope, scheduling, and pricing are agreed with you before work begins.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Acceptable use</h2>
      <p>
        You agree to use our site and services only for lawful purposes and not to misuse our systems or other customers’ information.
      </p>
      <h2 className="text-xl font-semibold text-secondary-900 mt-6 mb-2">Contact</h2>
      <p>
        Questions about these terms? Contact driscolledward@att.net.
      </p>
    </PolicyPage>
  );
}
